import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { ApiError, auth } from "../../api/client";
import { useAuth } from "../../auth/AuthContext";
import { useBodyClass } from "./useBodyClass";
import "../../styles/legacy/LoginView.css";
import { LoginDialog } from "./LoginDialog";

/** Landing page of the reset link in the "forgot password" email. */
export function ResetPasswordPage() {
  useBodyClass("login-page");
  useBodyClass("season-fall");
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [status, setStatus] = useState("");

  async function onSubmit(e?: FormEvent) {
    e?.preventDefault();
    if (p1.length < 8) return setStatus("Use at least 8 characters.");
    if (p1 !== p2) return setStatus("Passwords don't match.");
    try {
      const res = await auth.reset(token, p1);
      setUser(res.user);
      navigate("/library");
    } catch (err) {
      setStatus(err instanceof ApiError ? err.message : "Could not reset the password.");
    }
  }

  return (
    <div className="LoginView">
      <LoginDialog title="Choose a new password" intro="Pick a new password for your GearGrams account. At least 8 characters.">
        <form onSubmit={onSubmit}>
          <label htmlFor="reset-p1">New password</label>
          <input id="reset-p1" type="password" autoFocus value={p1} onChange={(e) => (setP1(e.target.value), setStatus(""))} />
          <label htmlFor="reset-p2">Retype password</label>
          <input id="reset-p2" type="password" value={p2} onChange={(e) => (setP2(e.target.value), setStatus(""))} />
          <div className="status error" role="status">
            {status}
          </div>
          <div className="actions">
            <button type="submit">Save password</button>
          </div>
        </form>
      </LoginDialog>
    </div>
  );
}
